module.exports = __webpack_public_path__ + "img/signal-02.a7a47b14.svg";